import _ from "lodash";

const reducer = async (action, data, state, prevState) => {

  switch (action) {
    case "GET":

      let listIZobraz = _.cloneDeep(data.obj.self.state.allListIZobraz)
      let listGridIZobraz = _.cloneDeep(data.obj.self.state.allListGridIZobraz);
      if (state.IAkcFrmpodSkupUz.detailData.Akc && !state.IAkcFrmpodSkupUz.detailData.Akc.NMaska) {
        listGridIZobraz = listGridIZobraz.filter(x => x.I_HOD !== 2)
        listIZobraz.data = listIZobraz.data.filter(x => x.I_HOD !== 2)
      }

      return { ...state, listIZobraz, listGridIZobraz }

    case "GET_SCHEMA":
      const allListIZobraz = _.cloneDeep(data.obj.self.state.listIZobraz)
      const allListGridIZobraz = _.cloneDeep(data.obj.self.state.listGridIZobraz)
      return { ...state, allListGridIZobraz, allListIZobraz }

    default:
      return state;
  }

}

export default reducer;